import Grid from '@mui/material/Grid2';
import InvestmentEfficiencyChart from '../../ShareMasterFollower/Charts/InvestmentEfficiencyChart';
import ProfitLossHistoryChart from '../../ShareMasterFollower/Charts/ProfitLossHistoryChart';
import CopyStatisticsChart from '../../ShareMasterFollower/Charts/CopyStatisticsChart';
import MasterPointChart from '../../ShareMasterFollower/Charts/MasterPointChart';
import AllocationChartRealtime from '../AllocationChartRealtime/AllocationChartRealtime';
import HoldingPortfolioRealtime from '@/views/components/CopyTrade/Master/HoldingPortfolio/HoldingPortfolioRealtime';
import EventEmitter from 'eventemitter3';
import { useCosInfo } from '@/controllers/gridManager/accountsManager/accountManager';
const ee = new EventEmitter()

const PortfolioManagementMain = () => {
    const { cosInfo } = useCosInfo()

    return (
        <Grid container spacing={3} columns={12}>
            <Grid size={6}>
                <AllocationChartRealtime emitter={ee} />
            </Grid>

            <Grid size={6}>
                <HoldingPortfolioRealtime emitter={ee} />
            </Grid>

            <Grid size={6} height={"390px"}>
                <InvestmentEfficiencyChart
                    fullWidth={true}
                    accountId={cosInfo.refaccount}
                    cosrole={cosInfo.cosrole}
                    isPrivate={true}
                />
            </Grid>


            <Grid size={6} height={"390px"}>
                <ProfitLossHistoryChart
                    fullWidth={true}
                    accountId={cosInfo.refaccount}
                    masterAccount=''
                    cosrole='M'
                    isPrivate={true}
                />
            </Grid>

            <Grid size={6} height={"390px"}>
                <CopyStatisticsChart
                    fullWidth={true}
                    accountId={cosInfo.refaccount}
                    isPrivate={true}
                />
            </Grid>

            <Grid size={6} height={"390px"}>
                <MasterPointChart accountId={cosInfo.refaccount}
                    isPrivate={true}
                />
            </Grid>
        </Grid>
    );
};

export default PortfolioManagementMain;